import { render, staticRenderFns } from "./ModalAdministrativeConcepts.vue?vue&type=template&id=ba6e4cda&lang=pug&"
import script from "./ModalAdministrativeConcepts.vue?vue&type=script&lang=js&"
export * from "./ModalAdministrativeConcepts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports